// extracted by mini-css-extract-plugin
module.exports = {"showMoreOffers":"ShowMoreOffers_showMoreOffers__78tDE","arrow":"ShowMoreOffers_arrow__n9DAh","rotate":"ShowMoreOffers_rotate__JqF_h"};